import React from 'react';

const Step4Publish = ({ state, onExport, renderEntry, color, w, t }) => {
  const { confirmedOutput } = state;
  const c = color;

  if (!confirmedOutput) {
    return (
      <div style={{ padding: '40px 20px', textAlign: 'center', background: t.surface, borderRadius: '14px', border: `1px solid ${t.border}` }}>
        <div style={{ fontSize: '15px', color: t.textMuted, marginBottom: '12px' }}>Nessun output confermato. Genera un contenuto nello Step 2, poi confermalo nello Step 3.</div>
      </div>
    );
  }

  const entryColor = confirmedOutput.modeConfig?.color || c;

  return (
    <div style={{ padding: '20px', background: t.surface, borderRadius: '14px', border: `1px solid ${t.border}` }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
        <span style={{ fontWeight: 700, fontSize: '15px' }}>Output Confermato</span>
        <span style={{ padding: '3px 10px', borderRadius: '6px', background: `${entryColor}20`, color: entryColor, fontSize: '11px', fontWeight: 700 }}>{confirmedOutput.modeConfig?.name}</span>
        {confirmedOutput.generationDuration && <span style={{ fontSize: '11px', color: t.textFaint, fontFamily: "'JetBrains Mono', monospace" }}>{confirmedOutput.generationDuration}s</span>}
      </div>

      {/* Content preview */}
      <div style={{ marginBottom: '16px' }}>
        {renderEntry(confirmedOutput)}
      </div>

      {/* Action row */}
      <div style={{ display: 'flex', gap: '10px' }}>
        <button onClick={() => onExport(confirmedOutput)} style={{ padding: '14px 22px', borderRadius: '10px', background: w(0.04), border: `1px solid ${t.border}`, color: t.textMuted, fontSize: '13px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
          ↓ Scarica .txt
        </button>
        <button disabled style={{ flex: 1, padding: '14px', borderRadius: '10px', background: `linear-gradient(135deg, #6366F1, #6366F1CC)`, border: 'none', color: '#fff', fontSize: '15px', fontWeight: 600, cursor: 'not-allowed', opacity: 0.5 }}>
          Pubblica contenuto (in arrivo)
        </button>
      </div>
      <p style={{ marginTop: '8px', textAlign: 'center', fontSize: '10px', color: t.textFaint, fontFamily: "'JetBrains Mono', monospace" }}>
        Pubblicazione diretta su canali social e CMS — in arrivo
      </p>
    </div>
  );
};
export default Step4Publish;
